import { render } from "./locationMaster.vue?vue&type=template&id=5cf733f2&scoped=true"
import script from "./locationMaster.vue?vue&type=script&lang=js"
export * from "./locationMaster.vue?vue&type=script&lang=js"

import "./locationMaster.vue?vue&type=style&index=0&id=5cf733f2&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf733f2"]])

export default __exports__